<script>
import { useAlert } from 'dashboard/composables';
import NextDialog from 'dashboard/components-next/dialog/Dialog.vue';
import SlaForm from './SlaForm.vue';

export default {
  components: {
    NextDialog,
    SlaForm,
  },
  emits: ['close'],
  mounted() {
    this.$refs.dialogRef?.open();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    async addSLA(payload) {
      try {
        await this.$store.dispatch('sla/create', payload);
        useAlert(this.$t('SLA.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error.message || this.$t('SLA.ADD.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <NextDialog
    ref="dialogRef"
    width="xl"
    overflow-y-auto
    :title="$t('SLA.ADD.TITLE')"
    :description="$t('SLA.ADD.DESC')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="onClose"
  >
    <SlaForm
      :submit-label="$t('SLA.FORM.CREATE')"
      @submit-sla="addSLA"
      @close="onClose"
    />
    <template #footer />
  </NextDialog>
</template>
